export const ProductContract  = {
    
    async get_products_by_client_id(client_id) {
        client_id;

        throw new Error("products get_products_by_client_id not implemented");
    },
    
    async show(product_id) {
        product_id;
        
        throw new Error("products show not implemented");
    },

    async index(page, per_page, search) {
        page;
        per_page;
        search;
        
        throw new Error("products index not implemented");
    },

    async get_product_image(product_id) {
        product_id;

        throw new Error("products get_product_image not implemented");
    },

    async product_show_reserved(product_id) {
        product_id;

        throw new Error("products product_show_reserved not implemented");
    }
}